class ConfigProviderManager {
	private static instance: ConfigProviderManager;
	private googleApiKey: string | null = null;
	private dataUrl: string | null = null;
	private brand: string | null = null;
	private bffUrl: string | null = null;
	private bffCdnUrl: string | null = null;
	private bffHeaders: Object | null = null;

	private constructor() {}

	static getInstance(): ConfigProviderManager {
		if (!ConfigProviderManager.instance) {
			ConfigProviderManager.instance = new ConfigProviderManager();
		}
		return ConfigProviderManager.instance;
	}

	setConfigs(configs?: any): void {
		this.brand = configs['es-vwdata']?.customConfig?.brand || null;

		this.dataUrl = configs['es-vwdata']?.urlOrigin + configs['es-vwdata']?.urlPath + '/' + this.brand;

		this.bffUrl = configs['es-oneform-bff']?.urlOrigin + configs['es-oneform-bff']?.urlPath;
		this.bffCdnUrl = configs['es-oneform-bff-cdn']?.urlOrigin + configs['es-oneform-bff-cdn']?.urlPath;
		this.bffHeaders = configs['es-oneform-bff-cdn']?.customConfig || null;

		this.googleApiKey = configs['es-google-apikey']?.customConfig?.apiKey || null;
	}

	getDataUrl(): string | null {
		return this.dataUrl;
	}

	getBrand(): string | null {
		return this.brand;
	}

	getBffUrl(): string | null {
		return this.bffUrl;
	}

	getBffCdnUrl(): string | null {
		return this.bffCdnUrl;
	}

	getBffHeaders(): Object | null {
		return this.bffHeaders;
	}

	getGoogleApiKey(): string | null {
		return this.googleApiKey;
	}
}

export const configProviderManager = ConfigProviderManager.getInstance();
